// frontend/src/lib/proration.js
/**
 * Business-days elapsed / total in the given YYYY-MM month, computed from
 * either today (default) or an arbitrary date. Mon-Fri only — does not
 * account for holidays. For MTD forecast proration this is "close enough"
 * given that monthly payroll lumps + recurring payments tend to fall on
 * weekdays anyway.
 */
function isBusinessDay(date) {
  const d = date.getDay();
  return d >= 1 && d <= 5;
}

export function businessDaysInMonth(year, month1Indexed) {
  let count = 0;
  const d = new Date(year, month1Indexed - 1, 1);
  while (d.getMonth() === month1Indexed - 1) {
    if (isBusinessDay(d)) count++;
    d.setDate(d.getDate() + 1);
  }
  return count;
}

export function businessDaysElapsedInMonth(year, month1Indexed, asOf = new Date()) {
  if (asOf.getFullYear() !== year || asOf.getMonth() !== month1Indexed - 1) {
    // Out of the month range — return the full count
    return businessDaysInMonth(year, month1Indexed);
  }
  let count = 0;
  const d = new Date(year, month1Indexed - 1, 1);
  while (d <= asOf && d.getMonth() === month1Indexed - 1) {
    if (isBusinessDay(d)) count++;
    d.setDate(d.getDate() + 1);
  }
  return count;
}

export function prorateForecast({ forecastFullMonth, year, month, asOf }) {
  const total = businessDaysInMonth(year, month);
  if (total === 0) return forecastFullMonth;
  const elapsed = businessDaysElapsedInMonth(year, month, asOf || new Date());
  return Math.round(forecastFullMonth * (elapsed / total));
}
